<template>
  <div>
    <div class="header"></div>
    <div class="container">
      <div class="title">
        <div class="title-l">套餐类型</div>
      </div>

      <div
        v-for="(item, index) in goodsTypeList"
        :key="index"
        class="list"
        :class="item.isSelect ? 'active' : 'noActive'"
        @click="selectGoods(item)"
      >
        <img
          :src="item.image"
          style="width: 108px;height: 108px;border-radius: 10px;margin-right: 10px;"
        />
        <div class="item">
          <div style="font-weight: bold;font-size: 16px;">
            {{ item.type_name }}
          </div>
          <div style="margin-top: 10px;font-size: 14px;">
            <div v-for="info in item.info" :key="info">{{ info }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="flex_r" @click="submint">立即兑换</div>
    </div>
  </div>
</template>

<script>
import { postGoodsCardType } from "@api/user";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
export default {
  //name: "ActiveExchangeGoods",
  data() {
    return {
      isSelect: false,
      params: {},
      dataObj: [],
      tabIndex: 0,
      goodsIndex: "",
      sum: 0,
      submintData: [],
      selectGoodsInfo: [],
      goodsTypeList: {}
    };
  },
  created() {
    let { u, p, t } = this.$route.query;
    this.params = {
      group_id: t,
      number: u,
      password: p
    };
    // 创建存储商品数据
    this.getData();
  },
  computed: {},
  methods: {
    submint() {
      let { u, p, t } = this.$route.query;
      let that = this;
      this.isSelect = null;
      this.goodsTypeList.forEach(item => {
        if (item.isSelect) {
          this.isSelect = item.isSelect;
        }
      });
      if (!this.isSelect) {
        Toast(`请选择一件商品！`);
        return;
      }

      that.$router.push({
        path: "/user/select_goods_card",
        query: {
          g: this.selectGoodsInfo.goods_id,
          l: this.selectGoodsInfo.limit_area,
          u,
          p,
          t
        }
      });
    },
    //
    selectGoods(item) {
      console.log("=--==-=->", item);
      this.selectGoodsInfo = item;
      this.goodsTypeList.forEach(a => {
        this.$set(a, "isSelect", false);
      });
      this.$set(item, "isSelect", true);
    },

    getData() {
      let data = this.params;
      postGoodsCardType(data).then(res => {
        console.log("获取数据---", res);
        res.data.forEach(x => {
          x.info = x.info ? x.info.split("<br/>") : [];
        });
        this.goodsTypeList = res.data;
        console.log(res.data);
      });
    }
  }
};
</script>

<style scoped>
body {
  background-color: #f9f9f9;
}
.active {
  border: 2px solid #e93323;
}
.noActive {
  border: 2px solid transparent;
}
.header {
  width: 100%;
  height: 200px;
  background: linear-gradient(180deg, #00a55e 0%, #ffffff 100%);
}
.container {
  width: 90%;
  padding: 10px 15px;
  background: #fff;
  border-radius: 8px;
  margin: auto;
  position: relative;
  top: -120px;
}
.container .title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}
.container .title-l {
  font-size: 20px;
  font-weight: bold;
  color: #09925a;
}
.container .title-l .rxlj,
.container .title-l .yx {
  font-size: 15px;
  font-weight: bold;
}

.container .title-l .yx {
  color: #f95244;
  padding-left: 5px;
}
.btn-r2 {
  border-radius: 100%;
  width: 20px;
  height: 20px;
  text-align: center;
  background-color: #9b9b9b;
  color: #f7f7f7;
}
.btn-r3 {
  border-radius: 100%;
  width: 20px;
  height: 20px;
  text-align: center;
  background-color: #f95244;
  color: #f7f7f7;
}
.container .title-zk {
  border: 1px solid rgba(249, 82, 68, 0.48);
  border-radius: 24px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 30px;
  width: 83px;
  background-color: #f95244;
  color: #fff;
  font-weight: bold;
}
.container .title-zk .text {
  font-size: 10px;
}
.btn2 {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f95244;
  color: #ffffff;
  font-weight: bold;
  margin-right: 10px;
}
.container .title-r {
  height: 30px;
  width: 83px;
  border: 1px solid rgba(249, 82, 68, 0.48);
  border-radius: 24px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.container .title-r .text,
.container .title-r .icon {
  font-size: 13px;
  color: #f95244;
  font-weight: bold;
}
.container .title-r .icon {
  position: relative;
  top: -2px;
  left: 4px;
}
.list {
  margin-top: 17px;
  width: 100%;
  border-radius: 10px;
  background: #f7f7f7;
  padding: 5px;
  display: flex;
}
.list .item {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.list .item .t-l {
  font-size: 14px;
  width: 75%;
}
.list .item .btn-r .btn1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.btn-r {
  border-radius: 0.4em;
  /* border: 1px solid #B4B4B4; */
  float: right;
}
.list .item .btn-r .btn1 .btn_l {
  width: 25px;
  height: 25px;
  text-align: center;
  line-height: 25px;
}
.list .item .btn-r .btn1 .q {
  border-top: 1px solid #b4b4b4;
  border-bottom: 1px solid #b4b4b4;
  border-left: none;
  border-right: none;
}
.list .item .btn-r .btn1 .r {
  background-color: #f95244;
  border: 1px solid #f95244;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  font-size: 20px;
  color: #f7f7f7;
}

.list .item .btn-r .btn1 .r:active {
  background-color: #f81805;
}

.list .item .btn-r .btn1 .l {
  border: 1px solid #b4b4b4;
  border-bottom-left-radius: 15px;
  border-top-left-radius: 15px;
  font-size: 20px;
}
.org {
  color: #f95244;
}
.footer {
  width: 100%;
  padding: 15px 10px 33px 10px;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
}
.footer .flexl {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
}
.footer .flex_l {
  display: flex;
  align-items: center;
}
.footer .flex_l .flex label {
  font-weight: 600;
}

.footer .flex_l .flex span {
  font-size: 13px;
  display: contents;
}

.footer .flex_r {
  background-color: #e93323;
  width: 100%;
  height: 40px;
  font-size: 15px;
  line-height: 40px;
  border-radius: 30px;
  text-align: center;
  color: #fff;
}

.footer .flex_r:active {
  background-color: #f81805;
}

.bor {
  height: 20px;
}
</style>
